var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disclaimer"},[_c('p',[_vm._v(_vm._s(_vm.$_getTranslations.home_store_vat_description_pt1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$_getTranslations.home_store_vat_description_pt2))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d0f246","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/store/section/VatSection.vue
// module id = null
// module chunks = 